<template>
  <div
    v-if="room && $route.name != 'Dashboard' && $route.name != 'Search'"
    class="user-chat w-100 overflow-hidden"
  >
    <div class="user-chat-overlay"></div>

    <div class="chat-content d-lg-flex">
      <!-- start chat conversation section -->
      <div class="w-100 overflow-hidden position-relative">
        <!-- conversation user -->
        <div id="users-chat" class="position-relative">
          <div class="p-3 p-lg-4 user-chat-topbar">
            <div class="row align-items-center">
              <div class="col-sm-4 col-8">
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0 d-block d-lg-none me-3">
                    <a @click="test" class="user-chat-remove font-size-18 p-1 btn btn-primary"
                      ><i class="bx bx-chevron-left align-middle"></i
                    ></a>
                  </div>
                  <div class="flex-grow-1 overflow-hidden">
                    <div class="d-flex align-items-center">
                      <div class="flex-grow-1 overflow-hidden">
                        <h3
                          class="user-profile-show text-reset text-capitalize"
                        >
                          {{ room.title }}
                        </h3>
                        <p class="text-truncate text-muted mb-0">
                          <small>{{
                            $store.state.utils.filters.stringLimit(
                              room.description,
                              20
                            )
                          }}</small>
                        </p>
                        <div class="small text-muted">
                          <i class="fa-solid fa-message text-primary me-1"></i>
                          {{ messagesCount }}&nbsp; Messages
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-8 col-4">
                <ul class="list-inline user-chat-nav text-end mb-0">
                  <li
                    class="list-inline-item d-none d-lg-inline-block me-2 ms-0"
                  >
                    <button
                      type="button"
                      class="btn btn-link user-profile-show"
                      @click="openUserProfileSidebar"
                    >
                      <i class="fa-solid fa-circle-info"></i>
                    </button>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <!-- end chat user head -->

          <!-- start chat conversation -->

          <div
            class="chat-conversation p-3 p-lg-4"
            id="chat-conversation"
            data-simplebar
          >
            <ul
              class="list-unstyled chat-conversation-list"
              id="users-conversation"
            >
              <li
                v-for="message in messages"
                :key="message.uid"
                :id="'msg' + message.uid"
                class="chat-list"
                v-bind:class="
                  message.owner.uid == $store.state.modules.account.user.uid
                    ? 'right'
                    : 'left'
                "
              >
                <div class="conversation-list">
                  <!-- TODO @muaz if (userChatId != isChat.from_id) ' -->

                  <div
                    class="chat-avatar"
                    :title="
                      message.owner.firstname + ' ' + message.owner.lastname
                    "
                  >
                    <img
                      v-if="
                        message.owner.profile_image &&
                        message.owner.profile_image != 'non'
                      "
                      :src="message.owner.profile_image"
                      alt="user"
                    />
                    <img
                      v-else
                      :src="
                        $store.state.config.frontpoint +
                        'storage/default-user-photo.png'
                      "
                      alt="user"
                    />
                  </div>

                  <div class="user-chat-content">
                    <div class="text-muted small">{{ message.subtitle }}</div>
                    <div class="ctext-wrap mb-0">
                      <div class="ctext-wrap-content" id="x">
                        <div
                          class="text-start"
                          type="button"
                          v-if="message.reply"
                          @click="goto(message.reply.uid)"
                        >
                          <div
                            class="border-start border-dark px-2 pb-1 fw-bold"
                          >
                            {{
                              $store.state.utils.filters.stringLimit(
                                message.reply.message,
                                30
                              )
                            }}
                          </div>
                        </div>
                        <p class="mb-0 mt-1 text-start ctext-content">
                          {{ message.message }}
                        </p>
                      </div>

                      <div class="dropdown align-self-start message-box-drop">
                        <a
                          class=""
                          href="#"
                          role="button"
                          data-bs-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="ri-more-2-fill"></i>
                        </a>
                        <div class="dropdown-menu">
                          <div
                            class="btn dropdown-item d-flex align-items-center justify-content-between reply-message"
                            @click="relatedMessage(message)"
                          >
                            Reply <i class="bx bx-share ms-2 text-muted"></i>
                          </div>

                          <a
                            v-if="
                              message.owner.uid ==
                              $store.state.modules.account.user.uid
                            "
                            class="dropdown-item d-flex align-items-center justify-content-between delete-item"
                            @click="deleteMsg(message.uid)"
                            >Delete <i class="bx bx-trash text-muted ms-2"></i
                          ></a>
                        </div>
                      </div>
                    </div>
                    <div class="conversation-name">
                      <small class="text-muted time">
                        {{ message.created_at }}
                      </small>
                      <span class="text-success check-message-icon">
                        <i class="bx bx-check-double"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>

          <!-- end chat conversation end -->
          <!-- </div> -->

          <!-- start chat input section -->
          <div class="position-relative">
            <div class="chat-input-section px-3 pt-3">
              <div class="chat-input-count small">
                {{ message.length }} / 1500
              </div>
              <form id="chatinput-form" enctype="multipart/form-data">
                <div class="row g-0 align-items-center  position-relative">
                  <input
                    type="text"
                    aria-label="Title"
                    class="form-control chat-input chat-input-title"
                    v-model="subtitle"
                    id="chat-input"
                    placeholder="Title"
                  />
                  <div class="input-group mb-3">
                    <div class="form-control p-0 w-75">
                      <span
                        v-if="related"
                        class="input-group-text chat-input-reply bg-primary-dark"
                        id="message"
                      >
                        <i class="fa-solid fa-reply me-2"></i>
                        {{ $store.state.utils.filters.stringLimit(related.message,20) }}
                        <span class="ms-auto btn-link" @click="unrRelated">
                          <i class="fa-solid fa-xmark"></i>
                        </span>
                      </span>
                      <textarea
                        rows="2"
                        autocomplete="off"
                        type="text"
                        class="chat-input form-control chat-input-message"
                        v-model="message"
                        id="messageInput"
                        aria-describedby="message"
                        placeholder="Message"
                      />
                    </div>
                    <button
                      type="submit"
                      class="btn btn-primary input-group-text btn-lg chat-send waves-effect waves-light"
                      @click="sendMessage"
                    >
                      <i class="bx bxs-send align-middle" id="submit-btn"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end chat input section -->
        </div>
        <!-- end chat conversation section -->

        <!-- start User profile detail sidebar -->
        <div class="user-profile-sidebar">
          <div class="p-3 container border-bottom">
            <div class="flex-grow-1">
              <button
                type="button"
                class="btn btn-link user-profile-show d-none d-lg-block"
                @click="openUserProfileSidebar"
              >
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div class="mt-5">
              <h3 class="text-primary fw-bold">{{ room.title }}</h3>
              <div class="small text-muted">
                Created by:&nbsp;<strong>{{ room.owner.username }}</strong>
              </div>
              <div class="small text-muted">
                Date created:&nbsp;<strong>{{ room.created_at }}</strong>
              </div>
              <p class="text-body mt-2">{{ room.description }}</p>
              <hr class="my-3" />
              <div class="list-group">
                <h4 class="text-primary font-size-18 fw-bold">
                  Chat participants:
                </h4>
                <div v-for="(member, index) in members" :key="index">
                  <router-link
                    :to="{
                      name: 'visitProfile',
                      params: { username: member.username },
                    }"
                    custom
                    v-slot="{ navigate }"
                    type="button"
                    class="list-group-item btn-link list-group-item-action"
                    title="Show profile"
                  >
                    <span
                      role="link"
                      class="btn btn-link"
                      @click="navigate"
                      aria-current="true"
                      @keypress.enter="navigate"
                    >
                      {{ member.username }}
                    </span>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <!-- End profile user -->
        </div>
        <!-- end User profile detail sidebar -->
      </div>
      <!-- end user chat content -->
    </div>
    <!-- End User chat -->
  </div>
  <div
    v-else-if="
      $store.state.modules.account.user.roles == 'administrator' &&
      $route.name != 'Search'
    "
    class="user-chat w-100 overflow-auto"
  >
    <elDashboard />
  </div>
  <div v-else class="user-chat w-100 overflow-hidden">
    <elSarch />
  </div>
</template>

<script>
import elDashboard from "./Dashboard.vue";
import elSarch from "./Search.vue";
import elDashboardUser from "./DashboardUser.vue";
export default {
  name: "ChatContainer",

  components: {
    elDashboard,
    elDashboardUser,
    elSarch,
  },

  data() {
    return {
      room: undefined,
      related: undefined,
      isInChat: false,
      isBottom: false,
      messages: {},
      members: {},
      rooms: {},
      message: "",
      subtitle: "",
      messagesCount: 0,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadRoom();
    });
  },

  watch: {
    "$route.path"() {
      this.loadRoom();
    },
  },

  methods: {
    // change name and a tag up
    test() {
      document.querySelector(".user-chat").classList.remove("user-chat-show");
    },
    openUserProfileSidebar() {
      let el = document.querySelector(".user-profile-sidebar").style;
      el.display = el.display == "block" ? "none" : "block";
    },

    loadRoom() {
      // console.log(this.$route.name);
      if (this.$route.params.id) {
        this.$store.state.modules.api
          .getRoom(
            this.$route.params.id,
            JSON.parse(localStorage.account).token
          )
          .then((resp) => {
            this.room = resp.data.unit;
            this.parent = undefined;
            this.messages = resp.data.unit.messages;
            this.members = resp.data.unit.members;
            this.rooms = resp.data.unit.rooms;
            this.messagesCount = Object.keys(resp.data.unit.messages).length;
            this.$store.state.utils.loaded = true;

            setTimeout(() => {
              document.querySelector("#messageInput").focus();
              if (!this.isBottom) {
                this.isBottom = true;
                const lastMessage = Object.values(this.messages).pop();
                this.goto(lastMessage.uid);
              }
              this.updateMessages();
            }, 100);
          });
      } else {
        // this.$router.push({ path: "/" });
      }
    },

    relatedMessage(message) {
      this.related = message;
      document.querySelector("#messageInput").focus();
    },

    unrRelated() {
      this.related = undefined;
      document.querySelector("#messageInput").focus();
    },

    deleteMsg(uid) {
      this.$store.state.modules.api
        .deleteMessageByUID(uid, JSON.parse(localStorage.account).token)
        .then((resp) => {
          if (resp.status == 200) {
            this.messages = resp.data.unit.messages;
            this.members = resp.data.unit.members;
            this.rooms = resp.data.unit.rooms;
            this.updateMessages();
            setTimeout(() => {
              document.querySelector("#messageInput").focus();

              this.isBottom = true;
              const lastMessage = Object.values(this.messages).pop();
              this.goto(lastMessage.uid);
            }, 100);
          }
        });
    },

    updateMessages() {
      if (this.$store.state.devEnv) return;
      window.clearTimeout(this.timeoutHandle);
      this.timeoutHandle = window.setInterval(() => {
        this.loadRoom();
      }, 5000);
    },
    goto(id) {
      let el = document.querySelector("#msg" + id);
      el.style.backgroundColor = "rgba(var(--bs-primary-rgb), 0.1)";
      el.scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
      setTimeout(() => {
        el.style.backgroundColor = "transparent";
      }, 1000);
    },

    sendMessage() {
      event.preventDefault();
      if (this.message.length > 1 && this.message.length < 1500) {
        this.$store.state.modules.api
          .setMessage(
            {
              parent: this.room.uid,
              related: this.related ? this.related.uid : null,
              message: this.message,
              subtitle: this.subtitle,
            },
            JSON.parse(localStorage.account).token
          )
          .then((resp) => {
            if (resp.status == 200) {
              this.room = resp.data.unit;
              this.messages = resp.data.unit.messages;
              this.members = resp.data.unit.members;
              this.rooms = resp.data.unit.rooms;
              this.updateMessages();
              this.related = undefined;
              this.message = "";
              setTimeout(() => {
                // TODO
                document.querySelector("#messageInput").focus();
                const lastMessage = Object.values(this.messages).pop();
                this.goto(lastMessage.uid);
              }, 100);
            }
          });
      } else {
        this.$store.state.utils.setNewNotifications(
          {
            type: "warning",
            message: "Please Enter your Message",
          },
          2500
        );
      }
    },
  },
  destroyed() {
    this.room = undefined;
  },
};
</script>
